import React, { useEffect, useState } from "react";
import { Row, Col, Steps, Step, Button, Slider, Alerts, Loader } from "@kaleyra/emmy";
import Styles from './index.module.scss';
import { useTranslation } from "react-i18next";
import cn from 'classnames'
import Approved from '../../../../../../assets/approved-neutral.svg';
import Timestamp from '../../../../../../assets/timestamp_fill.svg';
import { stepsType } from "../../../../../../interface";
import { isEmpty } from "lodash";
import { checkViewOnlyPrivileges, dateToStringFormat } from '../../../../../../utils';
import RejectedIcon from '../../../../../../assets/rejected.svg';

export type DispatchPropsType = {
    onClose: () => void;
    onEdit: (params: any) => void;
    onLoad: (params: any) => void;
};

export type MapStatePropsType = {
    params: any;
    templateViewDetails: any;
    inProgress: boolean;
    data: any;
};

type tabPropTypes = 'details' | 'timeline';

const TemplateView: React.FC<MapStatePropsType & DispatchPropsType> = ({
    onClose, onEdit, onLoad, params, templateViewDetails, inProgress, data
}) => {
    const [selectedTab, setSelectedTab] = useState<tabPropTypes>("details");

    const { t } = useTranslation();
    const isIndiaUser = (data.smsTemplatesData.is_India).toString() === "1";

    useEffect(() => {
        onLoad(params);
    }, [])

    const getStatusType = (status: any) => {
        if ((status.id).toString() === "1") {
            return "success";
        } else if ((status.id).toString() === "2") {
            return "warning";
        } else {
            return "error";
        }
    }

    const renderTimelineIcon = (action: string) => {
        switch (action) {
            case "UNDER-REVIEW":
                return <img src={Timestamp} alt="under review"/>;
            case "APPROVED":
                return <img src={Approved} alt="approved"/>;
            default:
                return <img src={RejectedIcon} alt="rejected"/>;
        }
    }

    const getBody = () => {
        const { title, purpose, sender_id, template_id, content, status, default_template } = templateViewDetails.templates[0];
        const { activity } = templateViewDetails;

        if (selectedTab === "details") {
            return <>
                {
                    ((status.id).toString() !== "3" && (status.id).toString() !== "2") && !Boolean(default_template) && !checkViewOnlyPrivileges('sms','templates') &&
                    <div className={cn(Styles.editBtnSection, Styles.flexEnd)}>
                        <Button type="secondary" className={Styles.editBtn} onClick={() => onEdit(params)}>{t('mainEdit')}</Button>
                    </div>
                }
                <div>
                    <p className={Styles.subheading}>{t('basicInformation')}</p>
                    <div className={Styles.infoContainer}>
                        <Row>
                            <Col size={6}>
                                <p className={Styles.infoTitle}>{t('mainTitle')}</p>
                            </Col>
                            <Col size={6}>
                                <p className={Styles.infoValue}>{title || '-'}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col size={6}>
                                <p className={Styles.infoTitle}>{t('assetsWidgetPurpose')}</p>
                            </Col>
                            <Col size={6}>
                                <p className={Styles.infoValue}>{purpose || '-'}</p>
                            </Col>
                        </Row>
                        {isIndiaUser &&
                            <Row>
                                <Col size={6}>
                                    <p className={Styles.infoTitle}>{t('verifySenderID')}</p>
                                </Col>
                                <Col size={6}>
                                    <p className={Styles.infoValue}>{sender_id || '-'}</p>
                                </Col>
                            </Row>
                        }
                        {isIndiaUser &&
                            <Row>
                                <Col size={6}>
                                    <p className={Styles.infoTitle}>{t('verifyTemplateId')}</p>
                                </Col>
                                <Col size={6}>
                                    <p className={Styles.infoValue}>{template_id || '-'}</p>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col size={6}>
                                <p className={Styles.infoTitle}>{t('KLR00109')}</p>
                            </Col>
                            <Col size={6}>
                                <p className={Styles.infoValue}>{content || '-'}</p>
                            </Col>
                        </Row>
                    </div>
                </div>
            </>
        }
        else {
            return <>
                <div className={Styles.alertWrapper}>
                    <Alerts className={Styles.alert} type={getStatusType(status)} content={`${t('mainTemplate')} ${status.label}`} showIcon={false} />
                </div>
                <div>
                    <p className={Styles.subheading}>{t('KLR00110')}</p>
                </div>
                <Steps direction="vertical" current={activity.length} type="default">
                    {
                        activity.map((listItem: stepsType, index: number) => {
                            const createdAt = new Date(listItem.created_at);
                            return (
                                <Step key={index}
                                    title={listItem.comments}
                                    description={`On ${dateToStringFormat(createdAt)}`}
                                    icon={renderTimelineIcon(listItem.action)}
                                />)
                        }
                        )
                    }
                </Steps>
            </>
        }
    }

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            tabs={
                [{
                    label: t('KLR00100'),
                    value: 'details',
                }, {
                    label: t('KLR00101'),
                    value: 'timeline'
                }]

            }
            onTabClick={(selectedTab) => setSelectedTab(selectedTab as tabPropTypes)}
            initActiveTab="details"
            visibility={true}
            title={t('KLR00111')}
        >
            <div className={Styles.container}>{(isEmpty(templateViewDetails) || inProgress) ? <Loader /> : getBody()}</div>
        </Slider >
    );


}

export default TemplateView;